import React, { useEffect, useState } from "react";
import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";
import { SolicitationProps } from "../../../../../../domain/models/solicitation.model";
import { StackModel } from "../../../../../../domain/models/stacks";
import RequestCustomer from "../../../../../../presentation/pages/admin/request-customer/form";
import { makeRemoteSolicitation } from "../../../../usecases/solicitation/remote-solicitation-factory";
import { makeRemoteStack } from "../../../../usecases/stack/remote-stack-factory";

function MakeCustomerForm({ match }: any): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const [data, setData] = useState<SolicitationProps>();
  const [loading, setLoading] = useState<boolean>(false);
  const [stackList, setStackList] = useState<StackModel[]>();

  const loadData = async (): Promise<void> => {
    setLoading(true);
    const stackResponse = await makeRemoteStack().loadAll();
    setStackList(stackResponse);
    const dataResponse = (await makeRemoteSolicitation().loadById(
      match?.params?.id
    )) as unknown as SolicitationProps;
    setData(dataResponse);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, user]);

  return (
    <RequestCustomer data={data} loading={loading} stackList={stackList} />
  );
}

export default MakeCustomerForm;
